// extracted by mini-css-extract-plugin
export default {"industryBanner":"styles_industryBanner__mx4qD","companiesNames":"styles_companiesNames__xjbx0"};